// extracted by mini-css-extract-plugin
export default {"bulkActionsIcon":"MaintainedDevicesList_bulkActionsIcon__R7J3t"};